/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { styles } from '@material-ui/pickers/views/Calendar/Calendar';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import React from 'react';
import { textMatcher } from '../../../../SharedModules/utilities/utilities';
import CustomGridCellRendererComponent from '../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';
const comparatorQtr = (a, b) => {
  const splittedQtrA = a?.split('Q');
  const splittedQtrB = b?.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};

export const InerestRecievedTableHead = [
  {
    headerName: 'Quarter',
    field: 'invRecQtr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_100,
    comparator: comparatorQtr,
    cellRenderer: 'GenericCodeTextBox',

    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Amount',
    field: 'interestPaidAmt',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    autoHeight: true,
    sortable: true,
    isTextColorRed: true,
    printPrefixValue: '$',
    minWidth: Styles.Width_150,
    cellRenderer: CustomGridCellRendererComponent,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: {
      borderRightColor: Styles.BorderColor,
      textAlign: 'right',
      display: 'flex',
      'justify-content': 'flex-end',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher,
    },
  },
];
